'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Spinner = require('./generic/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _CartStore = require('../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _CartItemsStructure = require('./cart-view/cart-right/CartItemsStructure.jsx');

var _CartItemsStructure2 = _interopRequireDefault(_CartItemsStructure);

var _CartLeftStructure = require('./cart-view/cart-left/CartLeftStructure');

var _CartLeftStructure2 = _interopRequireDefault(_CartLeftStructure);

var _Constants = require('./Constants');

var Constants = _interopRequireWildcard(_Constants);

var _reactRouterDom = require('react-router-dom');

var _Header = require('./common/Header');

var _Header2 = _interopRequireDefault(_Header);

var _Footer = require('./common/Footer');

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//wrapper functional component to pass params as props to main file.
function withCartItemRouter(Component) {
    function ComponentWithCartItemRouter(props) {
        // const navigate = useNavigate();
        var history = (0, _reactRouterDom.useHistory)();
        var params = (0, _reactRouterDom.useParams)();
        return _react2.default.createElement(Component, _extends({}, props, { history: history, params: params /* other hooks */ }, {
            params: params

        }));
    }
    return ComponentWithCartItemRouter;
}

var MyCart = function (_React$Component) {
    _inherits(MyCart, _React$Component);

    function MyCart(props) {
        _classCallCheck(this, MyCart);

        var _this = _possibleConstructorReturn(this, (MyCart.__proto__ || Object.getPrototypeOf(MyCart)).call(this, props));

        _this.renderContent = function () {
            var isMobile = _this.state.isMobile;
            if (isMobile) {
                return _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'section checkout-section ' },
                        _react2.default.createElement(
                            'div',
                            { className: 'container position-relative' },
                            _react2.default.createElement(_Spinner2.default, null),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(_Header2.default, null),
                                _react2.default.createElement(_CartLeftStructure2.default, {
                                    isMobile: _this.state.isMobile,
                                    handleUserLogin: _this.handleUserLogin,
                                    history: _this.props.history,
                                    locId: _this.props.params.locId
                                }),
                                _react2.default.createElement(_Footer2.default, null)
                            )
                        )
                    )
                );
            } else {
                return _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(_Header2.default, null),
                    _react2.default.createElement(
                        'div',
                        { id: 'myCart', className: 'section checkout-section ' },
                        _react2.default.createElement(
                            'div',
                            { className: 'container position-relative' },
                            _react2.default.createElement(_Spinner2.default, null),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(_CartLeftStructure2.default, {
                                    isMobile: _this.state.isMobile,
                                    handleUserLogin: _this.handleUserLogin,
                                    history: _this.props.history,
                                    locId: _this.props.params.locId
                                }),
                                _react2.default.createElement(_CartItemsStructure2.default, {
                                    isMobile: _this.state.isMobile,
                                    isLoggedInExistingUser: _this.state.isLoggedInExistingUser,
                                    history: _this.props.history,
                                    locId: _this.props.params.locId
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(_Footer2.default, null)
                );
            }
        };

        _this.state = {
            isMobile: false,
            isLoggedInExistingUser: false
        };

        _this._bind('updateWindowDimensions', 'handleUserLogin');

        return _this;
    }

    _createClass(MyCart, [{
        key: '_bind',
        value: function _bind() {
            var _this2 = this;

            for (var _len = arguments.length, methods = Array(_len), _key = 0; _key < _len; _key++) {
                methods[_key] = arguments[_key];
            }

            methods.forEach(function (method) {
                return _this2[method] = _this2[method].bind(_this2);
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {

            //for safari to scroll support wrap
            //scroll into setTimeOut
            window.setTimeout(function () {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "smooth"
                });
            }, 0);

            var self = this;
            var width = window.innerWidth;
            var mobView = width <= 767 ? true : false;

            self.setState({ isMobile: mobView });

            //add resize browser window listener
            window.addEventListener("resize", this.updateWindowDimensions);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            //remove resize browser window listener
            window.removeEventListener("resize", this.updateWindowDimensions);
        }
    }, {
        key: 'updateWindowDimensions',
        value: function updateWindowDimensions() {
            var width = window.innerWidth;

            this.setState({
                isMobile: width <= 767 ? true : false
            });
        }
    }, {
        key: 'handleUserLogin',
        value: function handleUserLogin(userStatus) {

            var self = this;
            self.setState({
                isLoggedInExistingUser: userStatus
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return this.renderContent();
        }
    }]);

    return MyCart;
}(_react2.default.Component);

//create highter order component.


var HOC_CART_ITEM = withCartItemRouter(MyCart);
exports.default = HOC_CART_ITEM;


//////////////////
// WEBPACK FOOTER
// ./src/components/MyCart.jsx
// module id = 560
// module chunks = 0